import {Link, useNavigate} from "react-router-dom";
import {useChatRooms} from "../../../hooks/useChat";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import ImageComponent from "../shared/ImageComponent";
import Loader from "../shared/Loader";
import ZipCodeIcon from "../../../images/icons/zipCode";
import NoImage from "../../../images/NoImage.jpg";
import {useRef, useState} from "react";
import InterventionModal from "./FinaliserModal";
import {useGetCategoryById, useGetCatgeory} from "../../../hooks/useCategory";
import {
  getInterventionStatusColor,
  getInterventionStatusLabel,
} from "../../../utils/status";
import {interventionStatus, userRoleList} from "../../../utils/constants";
import {useUpdateIntervention} from "../../../hooks/useInterventions";
import AvisModal from "./AvisModal";
import TicketModal from "./ticketModal";
import {proposalDate} from "../../../utils/date";
import CancelModal from "./cancelModal";
import ReportModal from "./ReportModal";
import {Dropdown} from "react-bootstrap";

export const InterventionInfoClient = ({className, intervention, user}) => {
  const offer = intervention?.Offer_Proposal?.Offer;
  const {
    data: chatrooms,
    isLoading,
    isError,
  } = useChatRooms({offerId: offer?.id, clientId: offer?.clientId});
  const {onUpdateIntervention, onFinalizeIntervention} =
    useUpdateIntervention();
  const [openModel, setOpenModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [isFinalizing, setIsFinalizing] = useState(false);
  const finalizingRef = useRef(false);

  const [ticketModal, setTicketModal] = useState(false);
  const navigate = useNavigate();

  const {title, SubCategories} = offer;
  const {
    data: categories,
    isLoading: categoryLoading,
    isError: categoryError,
  } = useGetCatgeory();

  if (isLoading || categoryLoading) return <Loader />;
  if (isError || categoryError)
    return <div>Erreur lors de la récupération de l'intervention</div>;

  const {bg, color} = getInterventionStatusColor({
    status: intervention?.status,
  });
  const statusLabel = getInterventionStatusLabel(intervention);

  const sector = categories?.find(
    (el) => el.id === SubCategories[0]?.fatherId,
  )?.Sector;

  const handleFinaliser = async () => {
    if (finalizingRef.current) return;
    finalizingRef.current = true;
    setIsFinalizing(true);
    try {
      if (!!intervention?.additionalPrice) {
        const params = new URLSearchParams({
          amount: intervention?.additionalPrice,
        }).toString();
        navigate(`/intervention/paiement/${intervention?.publicId || intervention?.id}?${params}`);
      } else {
        await onFinalizeIntervention({
          id: intervention?.id,
          body: {
            ended_byClient: true,
          },
        });

        setOpenModal(true);
      }
    } finally {
      finalizingRef.current = false;
      setIsFinalizing(false);
    }
  };

  return (
    <>
      <AvisModal
        openModal={openModel}
        toggleModal={setOpenModal}
        intervention={intervention}
      />
      <TicketModal
        openModal={ticketModal}
        toggleModal={setTicketModal}
        intervention={intervention}
      />
      <CancelModal
        openModal={cancelModal}
        toggleModal={setCancelModal}
        intervention={intervention}
      />
      <ReportModal
        openModal={reportModal}
        toggleModal={setReportModal}
        intervention={intervention}
        role={userRoleList.CLIENT}
      />
      <div className="w-full bg-white rounded-xl flex flex-col gap-2 p-6 justify-start items-start">
        <div className="w-full flex justify-between items-center flex-wrap-reverse">
          <div className="bg-[#F1F2F7] rounded-md flex !px-[10px] !py-[8px] gap-2 justify-center items-center text-xs font-semibold text-[#19295C] ">
            <ImageComponent
              src={buildImageUrl(sector?.imagePath)}
              alt="secteur"
              title={sector?.title}
              className=" w-5 "
              fallback={
                <img
                  src={NoImage}
                  alt=""
                  className=" w-5"
                  width="130"
                  title={sector?.title}
                />
              }
            />
            <span>{sector?.title}</span>
          </div>
          <div className="flex justify-end gap-3 items-center flex-grow">
            <div
              style={{
                backgroundColor: bg,
                color: color,
              }}
              className={`flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold `}
            >
              <div
                style={{
                  backgroundColor: color,
                }}
                className={`w-2 h-2 rounded-full `}
              ></div>
              <span>{statusLabel}</span>
            </div>
            {!!chatrooms?.length ? (
              <Link to={"/messages#" + chatrooms[0]?.id}>
                <div className="relative bg-[#EFF2F7] w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                  <i className="fi fi-rr-paper-plane flex items-center"></i>
                  {!!chatrooms?.length && (
                    <div class="absolute bg-[#FF6600] text-white text-[8px] font-semibold flex items-center justify-center rounded-full w-[11px] h-[11px] -top-1 -right-1 ">
                      {chatrooms.length}
                    </div>
                  )}
                </div>
              </Link>
            ) : (
              <div className="relative bg-[#EFF2F7]  w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                <i className="fi fi-rr-paper-plane flex items-center"></i>
              </div>
            )}
          </div>
        </div>
        <div className="w-full cursor-pointer text-[#19295C] hover:text-primary font-semibold text-xl break-all ">
          {intervention?.title ?? title ?? "--"}
        </div>
        <div className="flex justify-start items-center gap-2">
          <div className="text-dark flex flex-nowrap gap-2 text-[14px] text-nowrap mr-[10px]">
            <i className="fi fi-rr-calendar flex items-center"></i>

            {proposalDate(intervention?.startDate)}
          </div>
        </div>
        <div className=" text-primary font-semibold text-[16px] flex items-center mt-2 gap-1">
          <span className="text-xl mr-2">
            <i className="fi fi-rr-coins flex items-center"></i>
          </span>
          {intervention?.finalPrice}€
          {!!intervention?.additionalPrice && (
            <>
              <span>+{intervention?.additionalPrice}€</span>
              <span className="text-xs">(frais supplémentaire)</span>
            </>
          )}
        </div>

        <div className="flex justify-start items-center gap-2 mt-4  text-[#7E7E7E] font-bold text-[15px]">
          <ZipCodeIcon className="min-w-4 min-h-4 w-4 h-4 fill-[#1A64B9]" />{" "}
          <span>{offer?.address ?? "--"}</span>
        </div>
        <div className="flex w-full mt-2 gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
          <i className="fi fi-rr-info mt-[2px]"></i>{" "}
          <div className="text-[#7e7e7e] text-[15px]   ">
            {offer?.description ?? "--"}
          </div>
        </div>
        <div className="flex w-full  gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
          <i className="fi fi-rr-message-quote flex items-center"></i>
          <div className="text-[#7e7e7e] text-[15px]  leading-5 ">
            {!!intervention?.comment ? intervention?.comment : "--"}
          </div>
        </div>
        {(intervention?.reported_byClient && !intervention?.reported_byTech) ||
        (intervention?.reported_byTech &&
          !intervention?.reported_byClient) ? null : [
            interventionStatus.NEW,
            interventionStatus.REPORTED,
          ].includes(intervention?.status) ? (
          <div className="w-full px-2 sm:px-0 sm:grid grid-cols-2 gap-2 mt-4">
            <button
              onClick={() => setCancelModal(true)}
              type="button"
              className={`!rounded-md w-full !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase `}
            >
              Annuler l'intervention
            </button>
            <button
              onClick={() => setReportModal(true)}
              className=" !py-3 w-full  !rounded-md text-sm leading-4 gap-3 uppercase font-semibold flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
            >
              Reporter{" "}
            </button>
          </div>
        ) : (
          <div className="w-full grid grid-cols-2 gap-2 mt-4">
            {!intervention?.ended_byClient && (
              <button
                onClick={() => setTicketModal(true)}
                type="button"
                className={`!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase ${
                  !intervention?.ended_byTech ? "col-span-2" : ""
                }`}
              >
                Signaler un problème
              </button>
            )}
            {!intervention?.ended_byClient && intervention?.ended_byTech && (
              <button
                onClick={handleFinaliser}
                disabled={isFinalizing}
                aria-busy={isFinalizing}
                data-testid="intervention-client-finalize"
                type="button"
                className="!rounded-md !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm uppercase disabled:cursor-not-allowed disabled:opacity-60"
              >
                {isFinalizing
                  ? "Traitement..."
                  : !!intervention?.additionalPrice
                    ? "Payer"
                    : "Finaliser"}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export const InterventionInfoDirectClient = ({
  className,
  intervention,
  user,
}) => {
  const [openModel, setOpenModal] = useState(false);
  const [ticketModal, setTicketModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [isFinalizing, setIsFinalizing] = useState(false);
  const finalizingRef = useRef(false);
  const {onUpdateIntervention} = useUpdateIntervention();

  const {bg, color} = getInterventionStatusColor({
    status: intervention?.status,
  });
  const statusLabel = getInterventionStatusLabel(intervention);

  const navigate = useNavigate();

  const handleFinaliser = async () => {
    if (finalizingRef.current) return;
    finalizingRef.current = true;
    setIsFinalizing(true);
    try {
      if (!!intervention?.additionalPrice) {
        const params = new URLSearchParams({
          amount: intervention?.additionalPrice,
        }).toString();
        navigate(`/intervention/paiement/${intervention?.publicId || intervention?.id}?${params}`);
      } else {
        await onUpdateIntervention({
          id: intervention?.id,
          body: {
            ended_byClient: true,
          },
        });

        setOpenModal(true);
      }
    } finally {
      finalizingRef.current = false;
      setIsFinalizing(false);
    }
  };

  return (
    <>
      <AvisModal
        openModal={openModel}
        toggleModal={setOpenModal}
        intervention={intervention}
      />
      <TicketModal
        openModal={ticketModal}
        toggleModal={setTicketModal}
        intervention={intervention}
      />
      <CancelModal
        openModal={cancelModal}
        toggleModal={setCancelModal}
        intervention={intervention}
      />
      <ReportModal
        openModal={reportModal}
        toggleModal={setReportModal}
        intervention={intervention}
        role={userRoleList.CLIENT}
      />
      <div className="w-full bg-white rounded-xl flex flex-col gap-2 p-6 justify-start items-start">
        <div className="w-full flex justify-between items-center flex-wrap-reverse">
          <div className="flex justify-end gap-3 items-center flex-grow">
            <div
              style={{
                backgroundColor: bg,
                color: color,
              }}
              className={`flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold `}
            >
              <div
                style={{
                  backgroundColor: color,
                }}
                className={`w-2 h-2 rounded-full `}
              ></div>
              <span>{statusLabel}</span>
            </div>

            <Link
              to={
                "/messages#" +
                intervention?.Offer_Proposal?.directChat?.chatroomId
              }
            >
              <div className="relative bg-[#EFF2F7] w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                <i className="fi fi-rr-paper-plane flex items-center"></i>
              </div>
            </Link>
          </div>
        </div>
        <div className="w-full cursor-pointer text-[#19295C] hover:text-primary font-semibold text-xl ">
          {intervention?.title ?? "--"}
        </div>
        <div className="flex justify-start items-center gap-2">
          <div className="text-dark flex flex-nowrap gap-2 text-[14px] text-nowrap mr-[10px]">
            <i className="fi fi-rr-calendar flex items-center"></i>
            {proposalDate(intervention?.startDate)}
          </div>
        </div>
        <div className=" text-primary font-semibold text-[16px] flex items-center mt-2 gap-1">
          <span className="text-xl mr-2">
            <i className="fi fi-rr-coins flex items-center"></i>
          </span>
          {intervention?.finalPrice}€
          {!!intervention?.additionalPrice && (
            <>
              <span>+{intervention?.additionalPrice}€</span>
              <span className="text-xs">(frais supplémentaire)</span>
            </>
          )}
        </div>

        <div className="flex justify-start items-center gap-2 mt-4  text-[#7E7E7E] font-bold text-[15px]">
          <ZipCodeIcon className="w-4 min-w-4 min-h-4 h-4 fill-[#1A64B9]" />{" "}
          <span>{intervention?.Offer_Proposal?.address ?? "--"}</span>
        </div>

        <div className="flex w-full  gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
          <i className="fi fi-rr-message-quote flex items-center"></i>
          <div className="text-[#7e7e7e] text-[15px]  leading-5 ">
            {!!intervention?.comment ? intervention?.comment : "--"}
          </div>
        </div>

        {(intervention?.reported_byClient && !intervention?.reported_byTech) ||
        (intervention?.reported_byTech &&
          !intervention?.reported_byClient) ? null : [
            interventionStatus.NEW,
            interventionStatus.REPORTED,
          ].includes(intervention?.status) ? (
          <div className="w-full grid grid-cols-2 gap-2 mt-4">
            <button
              onClick={() => setCancelModal(true)}
              type="button"
              className={`!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase `}
            >
              Annuler l'intervention
            </button>
            <button
              onClick={() => setReportModal(true)}
              className=" !py-3 w-full  !rounded-md text-sm leading-4 gap-3 uppercase font-semibold flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
            >
              Reporter{" "}
            </button>
          </div>
        ) : (
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2 mt-4">
            {!intervention?.ended_byClient && !intervention?.ended_byTech && (
              <Dropdown className="w-full col-span-2">
                <Dropdown.Toggle
                  variant="white"
                  className="!rounded-md i-false  !py-3 w-full justify-center !text-[#0D44B1] !border-[#0D44B1] !border font-medium !text-sm uppercase d-flex align-items-center gap-2"
                >
                  Remonter un problème{" "}
                  <i className="fi fi-rr-angle-small-down flex items-center"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="p-0 !rounded-md w-full mt-2">
                  <Dropdown.Item
                    className="!text-[#3D4465] hover:!text-[#3D4465]"
                    onClick={() => setCancelModal(true)}
                  >
                    Annuler l'intervention
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="!text-[#3D4465] hover:!text-[#3D4465]"
                    onClick={() => setTicketModal(true)}
                  >
                    Faire une réclamation
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {!intervention?.ended_byClient && intervention?.ended_byTech && (
              <>
                <button
                  onClick={() => setTicketModal(true)}
                  type="button"
                  className={`!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase `}
                >
                  Signaler un problème
                </button>
                <button
                  onClick={handleFinaliser}
                  disabled={isFinalizing}
                  aria-busy={isFinalizing}
                  data-testid="intervention-direct-client-finalize"
                  type="button"
                  className="!rounded-md !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm uppercase disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {isFinalizing
                    ? "Traitement..."
                    : !!intervention?.additionalPrice
                      ? "Payer"
                      : "Finaliser"}
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};
